<template lang="pug">
	section#certificado
		div.wrapper
			h2 Certificação
			div.texto
				div.coluna._01
					p
						|O isolamento social exige uma das maiores mudanças no sistema 
						|educacional do país, em que todos os alunos, da educação básica ao 
						|ensino superior, foram colocados em ensino a distância. Pensando em como 
						|colaborar, disponibilizamos gratuitamente o conteúdo de um dos nossos cursos mais 
						|completos para preparar professores para o método EAD. Uma contribuição para apoiar 
						|milhares de professores a continuarem seguindo firme com seu propósito de ensinar 
						|milhões de alunos pelo Brasil e, assim, ajudar com desenvolvimento do seu “novo jeito” 
						|de ensinar. Ao final da jornada de 560h do módulo de disciplinas o aluno deverá optar por uma das 
						|2 formas de certificação possíveis:

				div.coluna._02
					h3 1. certificado de extensão
					p 
						|Emitido gratuitamente após a conclusão com êxito do primeiro módulo (módulo de disciplinas) ou,
					h3
						|2. Certificado de Pós-Graduação
						br
						span (Título de Especialista):
					p
						|Se desejar o título de pós-graduação, o aluno poderá contratar e se matricular no Módulo de TCC, com mais 60 horas, 
						|que contempla orientação e produção do trabalho de conclusão de curso, e receber a Certificação de Especialista como 
						|Pós-Graduado neste tema. Os custos deste módulo contemplam valores das disciplinas e orientação do professor.
						span (valor R$ 500,00).
					a(href="#", target="_blank").confiraRegulamento Confira o regulamento completo
</template>

<script>
export default {
	name: "section-certificado"
}
</script>

<style lang="stylus" scoped src="./Certificado.styl"></style>